/* ==========================================================================
   CarFusionElements — Produktgalerie

   Drei Aufgaben: Vorschau anklicken wechselt die Buehne, der Lichtregler
   laesst sich ziehen, ein Klick oeffnet den Kinomodus.

   Der Regler kommt ohne Zieh-Logik aus: Darueber liegt ein unsichtbarer
   Schieberegler des Browsers. Der bringt Maus, Finger und Tastatur schon
   mit — eigener Code dafuer waere mehr Zeilen und schlechter bedienbar.
   ========================================================================== */

(function () {
  'use strict';

  function starte(wurzel) {
    if (wurzel.dataset.galBereit === 'ja') return;
    wurzel.dataset.galBereit = 'ja';

    var hatRegler = wurzel.dataset.regler === 'true';
    var el = {
      regler: wurzel.querySelector('[data-gal-regler]'),
      reglerOben: wurzel.querySelector('[data-gal-regler-oben]'),
      griff: wurzel.querySelector('[data-gal-griff]'),
      schieber: wurzel.querySelector('[data-gal-schieber]'),
      einzel: wurzel.querySelector('[data-gal-einzel]'),
      buehnenbild: wurzel.querySelector('[data-gal-buehnenbild]'),
      lupe: wurzel.querySelector('[data-gal-lupe]'),
      vorschauen: [].slice.call(wurzel.querySelectorAll('[data-gal-vorschau]')),
      kino: wurzel.querySelector('[data-gal-kino]'),
      kinoBild: wurzel.querySelector('[data-gal-kino-bild]'),
      kinoZaehler: wurzel.querySelector('[data-gal-kino-zaehler]'),
      kinoZu: wurzel.querySelector('[data-gal-kino-zu]'),
      kinoVor: wurzel.querySelector('[data-gal-kino-vor]'),
      kinoZurueck: wurzel.querySelector('[data-gal-kino-zurueck]')
    };

    // Nur die sichtbaren Kacheln zaehlen — das zweite Bild des Reglerpaares
    // steckt in der Reglerkachel und ist im Raster ausgeblendet.
    var sichtbare = el.vorschauen.filter(function (v) {
      return !v.classList.contains('gal__vorschau--versteckt');
    });

    var zustand = { aktiv: 0, kinoIndex: 0 };

    /* --- Lichtregler ---------------------------------------------------- */

    function reglerZeichnen() {
      if (!el.schieber || !el.reglerOben) return;
      var wert = parseFloat(el.schieber.value);
      el.reglerOben.style.clipPath = 'inset(0 ' + (100 - wert) + '% 0 0)';
      if (el.griff) el.griff.style.left = wert + '%';
    }

    if (el.schieber) {
      el.schieber.addEventListener('input', reglerZeichnen);
      // Browser stellen Formularwerte beim Neuladen wieder her — der Regler
      // stuende dann dort, wo ihn der letzte Besuch gelassen hat (gemessen:
      // 3 % statt 50 %). Startwert deshalb ausdruecklich setzen.
      el.schieber.value = 50;
      reglerZeichnen();
    }

    /* --- Buehne wechseln ------------------------------------------------- */

    function buehneZeigen(vorschau) {
      var istRegler = vorschau.hasAttribute('data-gal-ist-regler');

      if (hatRegler && el.regler) {
        el.regler.hidden = !istRegler;
        if (el.lupe) el.lupe.hidden = !istRegler;
      }
      if (el.einzel) {
        el.einzel.hidden = istRegler;
        if (!istRegler && el.buehnenbild) {
          el.buehnenbild.src = vorschau.dataset.gross;
          el.buehnenbild.alt = vorschau.dataset.beschriftung || '';
        }
      }

      el.vorschauen.forEach(function (v) {
        v.classList.toggle('gal__vorschau--aktiv', v === vorschau);
      });
      zustand.aktiv = sichtbare.indexOf(vorschau);
      if (istRegler) reglerZeichnen();
    }

    el.vorschauen.forEach(function (v) {
      v.addEventListener('click', function () { buehneZeigen(v); });
    });

    /* --- Kinomodus ------------------------------------------------------- */

    function kinoZeigen(index) {
      if (!el.kino) return;
      var anzahl = sichtbare.length;
      zustand.kinoIndex = (index + anzahl) % anzahl;
      var v = sichtbare[zustand.kinoIndex];
      el.kinoBild.src = v.dataset.voll;
      el.kinoBild.alt = v.dataset.beschriftung || '';
      if (el.kinoZaehler) {
        el.kinoZaehler.textContent = (zustand.kinoIndex + 1) + ' von ' + anzahl;
      }
    }

    function kinoOeffnen() {
      if (!el.kino) return;
      kinoZeigen(zustand.aktiv);
      if (typeof el.kino.showModal === 'function') el.kino.showModal();
      else el.kino.setAttribute('open', '');
    }

    if (el.einzel) el.einzel.addEventListener('click', kinoOeffnen);
    if (el.lupe) el.lupe.addEventListener('click', kinoOeffnen);

    if (el.kinoZu) {
      el.kinoZu.addEventListener('click', function () { el.kino.close(); });
    }
    if (el.kinoVor) {
      el.kinoVor.addEventListener('click', function () { kinoZeigen(zustand.kinoIndex + 1); });
    }
    if (el.kinoZurueck) {
      el.kinoZurueck.addEventListener('click', function () { kinoZeigen(zustand.kinoIndex - 1); });
    }
    if (el.kino) {
      el.kino.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); kinoZeigen(zustand.kinoIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); kinoZeigen(zustand.kinoIndex - 1); }
      });
      // Klick auf die Flaeche neben dem Bild schliesst.
      el.kino.addEventListener('click', function (e) {
        if (e.target === el.kino) el.kino.close();
      });
    }

    /* --- Kopplung an die Lichtfarbe --------------------------------------
       Waehlt jemand im Kaufbereich eine andere Lichtfarbe, springt die
       Galerie auf das Bild, das im Admin an dieser Variante haengt.

       Das Theme wirft dafuer kein eigenes Event — der fruehere Listener auf
       "variant:change" lief deshalb ins Leere und der Farbkreis tat nichts.
       Was es gibt, ist das ganz normale change der Radiobuttons im
       <variant-picker>. Daran haengen wir uns. */

    function zuVariante(name) {
      if (!name) return;
      var gesucht = String(name).toLowerCase().trim();

      var treffer = sichtbare.filter(function (v) {
        var zugeordnet = (v.dataset.variante || '').toLowerCase();
        // Bei mehreren Optionen heisst die Variante "Gelb / 60x40" —
        // deshalb enthalten statt gleich.
        return zugeordnet && zugeordnet.indexOf(gesucht) !== -1;
      })[0];

      // Notnagel fuer Produkte, bei denen im Admin kein Variantenbild
      // gesetzt ist: dann nach der Bildbeschreibung suchen.
      if (!treffer) {
        treffer = sichtbare.filter(function (v) {
          return (v.dataset.beschriftung || '').toLowerCase().indexOf(gesucht) !== -1;
        })[0];
      }

      if (treffer) buehneZeigen(treffer);
    }

    document.addEventListener('change', function (e) {
      var feld = e.target;
      if (!feld || feld.type !== 'radio') return;
      if (!feld.closest('variant-picker')) return;
      zuVariante(feld.value);
    });

    // Startzustand einmal anwenden. Ohne das bleiben Regler und Einzelbild
    // beide versteckt und die Buehne ist leer — im Markup ist nur die
    // Vorschau als aktiv markiert, nicht die Buehne selbst.
    var start_aktiv = wurzel.querySelector('.gal__vorschau--aktiv') || sichtbare[0];
    if (start_aktiv) buehneZeigen(start_aktiv);

    // Beim Laden bleibt bewusst das erste Bild stehen, auch wenn schon eine
    // Farbe vorausgewaehlt ist. Das Variantenbild kommt erst, wenn jemand
    // einen Farbkreis anklickt.
  }

  function start() {
    document.querySelectorAll('[data-gal]').forEach(starte);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
